<script lang="ts" module>
	import { gsap } from 'gsap';
	import { ScrollTrigger } from 'gsap/ScrollTrigger';
	gsap.registerPlugin(ScrollTrigger);
</script>

<script lang="ts">
	import type { Snippet } from 'svelte';
	import { activeSection } from '$lib/global.svelte';
	import { lang } from '$lib/lang/copy.svelte';

	interface Props {
		children?: Snippet;
		padding?: boolean;
		padTop?: boolean;
		padBottom?: boolean;
		bordered?: boolean;
		borderTop?: boolean;
		borderBottom?: boolean;
		class?: Classes;
		id?: string;
	}

	let {
		children,
		padding = true,
		padTop = padding,
		padBottom = padding,
		bordered = false,
		borderTop = bordered,
		borderBottom = bordered,
		class: classes = '',
		...rest
	}: Props = $props();

	let section = $state<HTMLElement>();

	$effect(() => {
		if (activeSection.value === 'tobacco' && lang.current) {
			setTimeout(() => {
				ScrollTrigger.refresh();
			}, 1000);
		}
	});
</script>

<section
	{@attach (node: HTMLElement) => {
		ScrollTrigger.create({
			trigger: node,
			start: 'top center',
			end: 'bottom center',
			onEnter: () => (activeSection.value = rest?.id),
			onEnterBack: () => (activeSection.value = rest?.id)
		});
	}}
	bind:this={section}
	class={['border-gray relative', borderBottom && 'border-b', classes]}
	{...rest}
>
	{#if borderTop}
		<div class="content-well-sm border-gray border-t"></div>
	{/if}

	<div
		class={[
			'flex flex-col gap-10 transition-all duration-500 md:gap-16',
			padTop && 'pt-24',
			padBottom && 'pb-24'
		]}
	>
		{@render children?.()}
	</div>
</section>
